import { animations as o } from "./atoms-v2989.js";
import { drag as t } from "./atoms-v21062.js";
import { gestureAnimations as r } from "./atoms-v21063.js";
import { layout as m } from "./atoms-v21064.js";
import { createMotionComponentFactory as e } from "./atoms-v21065.js";
import { createDomVisualElement as i } from "./atoms-v21066.js";
const l = /* @__PURE__ */ e({
  ...o,
  ...r,
  ...t,
  ...m
}, i);
export {
  l as createMotionComponent
};
